import { createSlice } from '@reduxjs/toolkit';

import initialState, * as handlers from './handlers';

const feedback = createSlice({
  name: 'feedback',
  initialState,
  reducers: {
    setUpdateFeedback: handlers.setUpdateFeedback,
  },
});

const { actions, reducer } = feedback;

export const { setUpdateFeedback } = actions;

export default reducer;
